import _ from 'lodash';

import Input from 'components/Input';
import { ENUM_QUESTION_TYPE, ENUM_TYPE_ACTION, ENUM_TYPE_OPTION } from 'constants/enum';
import { TEXT_CREATE_SURVEY } from 'constants/string/texts';
import useCreateSurvey from 'hooks/useCreateSurvey';

import DropdownOption from './DropdownOption';

export const AddOptionButton = (props) => {
  const { onSaveStep } = useCreateSurvey();
  const { data, form, sectionIndex, questionIndex, typeOption } = props;

  const handleAddOption = () => {
    const newOption = {
      option_text: `${TEXT_CREATE_SURVEY.OPTION}${(form.values.sections[sectionIndex].questions[questionIndex]?.options?.length || 0) + 1}`,
      action: ENUM_TYPE_ACTION.CREATE,
    };
    form.setFieldValue(['sections', sectionIndex, 'questions', questionIndex, 'options'], [...(data?.options ?? []), newOption]);
    const question = form.values.sections[sectionIndex].questions[questionIndex];
    question.options = [...(data?.options ?? []), newOption];
    onSaveStep(form.values);
  };

  return (
    <div className="flex items-center gap-2 opacity-85" onClick={handleAddOption}>
      {typeOption === ENUM_TYPE_OPTION.DROPDOWN ? (
        <></>
      ) : (
        <Input
          id="add-option"
          checked={false}
          type={typeOption === ENUM_TYPE_OPTION.RADIO ? 'radio' : 'checkbox'}
          className={`flex-middle-center w-4 h-4 ${typeOption === ENUM_TYPE_OPTION.RADIO ? 'radio-button' : 'checkbox-button'}`}
          classNameInput="w-4 border-0 bg-transparent border-b border-dashed !border-gray-102/65 text-gray-102/65 !p-0"
        />
      )}
      <span className="underline text-gray-102/65">{TEXT_CREATE_SURVEY.ADD_OPTION}</span>
    </div>
  );
};

const RadioCheckbox = (props) => {
  const { onSaveStep } = useCreateSurvey();
  const { data, isPreview, viewOnly, questionEditing, form, sectionIndex, questionIndex } = props;

  const renderOptions = (typeOption = ENUM_TYPE_OPTION.RADIO) => {
    const handleChecked = (item) => {
      if (data.answer) {
        return _.findIndex(data.answer, (ans) => (_.isString(ans) ? ans === item.option_text : ans === item.id)) > -1;
      }
      return false;
    };

    return (
      <div className={!viewOnly ? 'mt-2' : ''}>
        {data?.options?.map((item, index) => (
          <div
            className={`flex items-start gap-2 mb-2 ${typeOption === ENUM_TYPE_OPTION.DROPDOWN && data?.answer && handleChecked(item) ? 'font-bold' : ''}`}
            key={`option-${index}`}
          >
            {typeOption === ENUM_TYPE_OPTION.DROPDOWN ? (
              <>{index + 1}. </>
            ) : (
              <Input
                readOnly
                checked={handleChecked(item)}
                name={data.id}
                type={typeOption === ENUM_TYPE_OPTION.RADIO ? 'radio' : 'checkbox'}
                className={`w-4 h-4 flex-middle-center mt-1.5 ${typeOption === ENUM_TYPE_OPTION.RADIO ? 'radio-button' : 'checkbox-button'}`}
                classNameInput="min-w-4 min-h-4 border-0 bg-transparent border-b border-dashed !border-gray-102/65 text-gray-102/65 !p-0"
              />
            )}
            {questionEditing ? (
              <Input
                value={item?.option_text}
                onChange={form.handleChange}
                className="!h-auto w-full"
                classNameInput="w-full border-0 bg-transparent focus:border-b border-solid border-black-102 text-black-102 !py-0 !pb-1 !px-1"
                name={`sections[${sectionIndex}].questions[${questionIndex}].options[${index}.option_text]`}
                onBlur={() => onSaveStep(form.values)}
              />
            ) : (
              <span className="text-black-102 break-all">{item?.option_text || ''}</span>
            )}
          </div>
        ))}
        {viewOnly ? <></> : <>{!isPreview && <AddOptionButton {...props} typeOption={typeOption} />}</>}
      </div>
    );
  };

  return (
    <>
      {data.question_type === ENUM_QUESTION_TYPE.RADIO ? (
        renderOptions(ENUM_TYPE_OPTION.RADIO)
      ) : data.question_type === ENUM_QUESTION_TYPE.CHECKBOX ? (
        renderOptions(ENUM_TYPE_OPTION.CHECKBOX)
      ) : (
        <DropdownOption data={data} {...props} renderOptions={renderOptions} />
      )}
    </>
  );
};

export default RadioCheckbox;
